import React from 'react';
import Helmet from 'react-helmet';
import './NotFound.scss';

const NotFound = props => {
  const {
    dataLocale: {
      CLICK,
      CONTACT_LENSES,
      DAMN,
      EYEGLASSES,
      HERE,
      MAGNETIC_CLIP_ONS,
      NEW_ARRIVALS,
      NOT_FOUND,
      SEEMS_LIKE_THE_PAGE_CANNOT_BE_FOUND,
      SUNGLASSES,
      TO_GO_BACK_TO_THE_HOME_PAGE,
    },
    localeInfo,
  } = props;
  // const { domain } = localeInfo;
  if (typeof window !== 'undefined' && window.dtm && window.dtm.LenskartRewamp) {
    window.dtm.LenskartRewamp.allPage('error page');
  }
  return (
    <div className="container">
      <Helmet title="Error Page" />
      <div className="std">
        <div className="no-route">
          <div className="row damn">
            <div className="col-xs-6 damn-title">
              <h1>{DAMN}</h1>
            </div>
            <div className="col-xs-6">
              <img alt={NOT_FOUND} src="//static.lenskart.com/media/desktop/img/404-new.jpg" />
            </div>
          </div>
          <div className="row text-center">
            <div className="damn-text">{SEEMS_LIKE_THE_PAGE_CANNOT_BE_FOUND}</div>
            {/* <div className="damn-text">{CLICK} <a href={typeof window !== 'undefined' ? window.location.origin : domain}>{HERE}</a> {TO_GO_BACK_TO_THE_HOME_PAGE}</div>
                    </div>
                    <ul className="lk_category">
                        <li><a href={typeof window !== 'undefined' ? `${window.location.origin}/sunglasses.html` : domain}>{SUNGLASSES} <span className="visible-xs">&gt;</span></a></li>
                        <li><a href={typeof window !== 'undefined' ? `${window.location.origin}/eyeglasses.html` : domain}>{EYEGLASSES} <span className="visible-xs">&gt;</span></a></li>
                        <li><a href={typeof window !== 'undefined' ? `${window.location.origin}/contact-lenses.htmll` : domain}>{CONTACT_LENSES} <span className="visible-xs">&gt;</span></a></li> */}
            <div className="damn-text">
              {CLICK} <a href="/">{HERE}</a> {TO_GO_BACK_TO_THE_HOME_PAGE}
            </div>
          </div>
          <ul className="lk_category">
            {localeInfo.countryCode === 'sg' && (
              <li>
                <a href="/sg/eyeglasses/collections/new-arrivals-eyeglasses.html">
                  {NEW_ARRIVALS} <span className="visible-xs">&gt;</span>
                </a>
              </li>
            )}
            <li>
              <a
                href={localeInfo.countryCode !== 'sg' ? '/sg/sunglasses.html' : '/sunglasses.html'}
              >
                {SUNGLASSES} <span className="visible-xs">&gt;</span>
              </a>
            </li>
            <li>
              <a
                href={localeInfo.countryCode !== 'sg' ? '/sg/eyeglasses.html' : '/eyeglasses.html'}
              >
                {EYEGLASSES} <span className="visible-xs">&gt;</span>
              </a>
            </li>
            {localeInfo.countryCode === 'sg' && (
              <li>
                <a href="/sg/eyeglasses/collections/clip-on-eyeglasses.html">
                  {MAGNETIC_CLIP_ONS} <span className="visible-xs">&gt;</span>
                </a>
              </li>
            )}
            {localeInfo.countryCode !== 'sg' && (
              <li>
                <a href="/contact-lenses.html">
                  {CONTACT_LENSES} <span className="visible-xs">&gt;</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
